import {useState} from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import styles from './EditClientName.module.scss';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ClientNameForm from "./ClientNameForm";

const EditClientName = ({ clientName, setClientName, onUpdate }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <EditOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
                <DialogTitle styles={`${styles.header} text-center`}>
                    Edit client name
                </DialogTitle>
                <ClientNameForm
                    clientName={clientName}
                    setClientName={setClientName}
                    onCancel={handleClose}
                    onUpdate={onUpdate}
                />
            </Dialog>
        </>
    );
}

export default EditClientName;
